/**
 * Added new facet constant
 */

export const FACET_PRICE_PREFIX = 'price_';
export const FACET_CATEGORY_VALUE = 'parentCatgroup_id_search';
export const FACET_CATEGORY_ENTRY_VALUE_PREFIX = 'path.tree:';
export const FACET_LIMIT_SUFFIX = ':-1';
export const FACET_STORE_LOCATOR_PREFIX = 'store.only';
export const FACET_LIMIT_STATE_KEY = 'facetLimitExpansion';
